import { post, get } from '../axios'

// 多语言发布包列表
export function pkg_list_post(map, option) {
  return post(
    `${process.env.VUE_APP_PKG}pkg/list?pageNum=${map.pageNum}&pageSize=${map.pageSize}`,
    map,
    option
  ).then(response => response)
}

// 发布多语言包
export function pkg_release_get(map, option) {
  return get(`${process.env.VUE_APP_PKG}pkg/release`, map, option).then(
    response => response
  )
}
// 发布多语言包APP
export function pkg_releaseApp_get(map, option) {
  return post(`${process.env.VUE_APP_PKG}pkg/releaseApp`, map, option).then(
    response => response
  )
}
// app 下载
export function pkg_download_package_get(map, option) {
  return get(
    `${process.env.VUE_APP_PKG}pkg/downloadPackage/${map.packageId}`,
    option
  ).then(response => response)
}

//
export function page_utils_page_version_update(map, option, id) {
  return post(
    `${process.env.VUE_APP_PAGE_UTILS_API}/version/update/${id}`,
    map,
    option
  ).then(response => response)
}

export function page_utils_page_version_push(map, option) {
  return get(
    `${process.env.VUE_APP_PAGE_UTILS_API}/version/push`,
    map,
    option
  ).then(response => response)
}

export function page_utils_page_version_list(map, option) {
  return get(`${process.env.VUE_APP_PAGE_UTILS_API}/version`, map, option).then(
    response => response
  )
}
